import { render, staticRenderFns } from "./AdressData.vue?vue&type=template&id=035091ab&scoped=true"
import script from "./AdressData.vue?vue&type=script&lang=js"
export * from "./AdressData.vue?vue&type=script&lang=js"
import style0 from "./AdressData.vue?vue&type=style&index=0&id=035091ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035091ab",
  null
  
)

export default component.exports